import { TableCell, TableSortLabel } from "@mui/material";

export const SortableTableCell = ({ field, label, currentSort, currentOrder, onSort }) => {
    const isActive = currentSort === field;
    return (

        <TableCell>
            <TableSortLabel
                active={isActive}
                direction={currentOrder}
                onClick={() => onSort(field)}
            >
                {label}
            </TableSortLabel>
        </TableCell>
    );
};